<template>
  <div class="app-content ap trash">
    <b-row class="row mb-4">
      <b-col cols="auto">
        <b-button @click="$router.go(-1)" class="btn btn-secondary btn-svg" title="Back to Monitor"><svg viewBox="0 0 492 492"><path d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z"/></svg></b-button>
      </b-col>
      <b-col>
        <div class="d-flex h-100 w-100 flex-column justify-content-center">
          <h1 class="ap__main-title text-danger mb-2">{{ type }} Trash</h1>
          <h5 class="font-weight-bold mb-0" v-if="type != 'monitors'">{{ monitorCurrent.monitor.name }} → {{ typeLabel }}s Trash</h5>
          <h5 class="font-weight-bold mb-0" v-else>{{ tagsNames[tagId] }} → Trash</h5>
        </div>
      </b-col>
    </b-row>

    <template v-if="isLoading">
      <div class="d-flex flex-column justify-content-center text-center align-items-center app__loading">
        <p><strong>Loading data...</strong></p>
        <b-spinner></b-spinner>
      </div>
    </template>
    <template v-else>
      <table class="table trash__table" v-if="trashObjects.length">
        <thead>
          <tr>
            <th>{{ type}} name</th>
            <th>Tags</th>
            <th>Date</th>
            <th>User</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="object in trashObjects" :key="object.id">
            <td class="trash__item-name">{{ object.name }}</td>
            <td>
              <span v-for="(tag, index) in object.generations" :key="tag">
                {{ tagsNames[tag] }}<template v-if="index < object.generations.length - 1">, </template>
              </span>
            </td>
            <td class="trash__item-date">{{ object.deletion_date | moment('YYYY-MM-DD HH:mm:ss') }}</td>
            <td><template v-if="object.deleted_from">{{ object.deleted_from }}</template></td>
            <td>
              <button class="trash__action mr-3" @click="restoreObject(object)" v-b-popover.hover.top="'Restore'"><svg viewBox="0 0 512 512"><path d="M142.716,293.147l-94-107.602l94-107.602c7.596-8.705,6.71-21.924-1.995-29.527c-8.705-7.596-21.917-6.703-29.527,1.995 L5.169,171.782c-6.892,7.882-6.892,19.65,0,27.532l106.026,121.372c4.143,4.729,9.94,7.157,15.771,7.157 c4.883,0,9.786-1.702,13.755-5.169C149.427,315.071,150.319,301.852,142.716,293.147z"/><path d="M359.93,164.619H20.926C9.368,164.619,0,173.986,0,185.545c0,11.558,9.368,20.926,20.926,20.926H359.93 c60.776,0,110.218,49.441,110.218,110.211S420.706,426.893,359.93,426.893H48.828c-11.558,0-20.926,9.368-20.926,20.926 c0,11.558,9.368,20.926,20.926,20.926H359.93c83.844,0,152.07-68.219,152.07-152.063S443.781,164.619,359.93,164.619z"/></svg></button>
              <button class="trash__action" @click="deleteObject(object)" v-b-popover.hover.top="'Delete permanently'"><svg viewBox="0 0 515.556 515.556"><path d="m64.444 451.111c0 35.526 28.902 64.444 64.444 64.444h257.778c35.542 0 64.444-28.918 64.444-64.444v-322.222h-386.666z"/><path d="m322.222 32.222v-32.222h-128.889v32.222h-161.111v64.444h451.111v-64.444z"/></svg></button>
            </td>
          </tr>
        </tbody>
      </table>
      <b-card
        v-else
        tag="article"
        class="text-center mb-3"
      >
        <b-card-text>
          The trash is empty
        </b-card-text>
      </b-card>
    </template>

    <MonitorTrashDelete :object="objectToDelete" :type="type" :typeLabel="typeLabel" v-on:objectDeleted="getTrashedObjects"/>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { monitorsDataMixin } from '../mixins/monitorsDataMixin.js';

import MonitorTrashDelete from "@/components/MonitorTrashDelete";

import {
  GLOBAL_CHANGE_SECTION,
  MONITOR_TRASH_GET,
  MONITOR_TRASH_RESTORE
} from "@/store/actions.type";

export default {
  name: 'MonitorsTrash',
  mixins: [monitorsDataMixin],
  components: {
    MonitorTrashDelete
  },
  data() {
    return {
      type: null,
      tagId: null,
      isLoading: true,
      tagsNames: {},
      trashObjects: {},
      objectToDelete: {}
    }
  },
  computed: {
    ...mapGetters(["isAuthenticated", "section", "monitorCategory", "monitorTags", "monitorCurrent"]),
    currentTag: function() {
      let filteredTags = this.monitorTags.filter(i => i.tag_id === this.tagId)
      return filteredTags[0];
    },
    typeLabel: function() {
      if(this.type == 'monitors') {
        return 'Monitor'
      } else if(this.type == 'chapters') {
        return 'Chapter'
      } else if(this.type == 'paragraphs') {
        return 'Paragraph'
      } else if(this.type == 'paragraph_objects') {
        return 'Paragraph object'
      } else {
        return false
      }
    }
  },
  methods: {
    generateTagsNames() {
      if(this.monitorCategory == 'consumer') {
        for (let i = 0; i < this.monitorConsumerGenerations.length; i++) {
          this.tagsNames[this.monitorConsumerGenerations[i].id] = this.monitorConsumerGenerations[i].generation;
        }
      } else {
        for (let j = 0; j < this.monitorMarketSectors.length; j++) {
          this.tagsNames[this.monitorMarketSectors[j].id] = this.monitorMarketSectors[j].sector;
        }
      }
    },
    getTrashedObjects() {
      let payload = {
        type: this.type,
        tagId: this.tagId
      }
      this.$store.dispatch(MONITOR_TRASH_GET, payload).then((data) => {
        this.trashObjects = data;
        this.isLoading = false;
      });
    },
    restoreObject(object) {
      let payload = {
        type: this.type,
        objectId: object.id
      }
      this.$store.dispatch(MONITOR_TRASH_RESTORE, payload).then(() => {
        this.$bvToast.toast(`${this.typeLabel} ${object.name} has been restored successfully`, {
          title: `${this.typeLabel} restored`,
          toaster: 'b-toaster-bottom-right',
          autoHideDelay: 4000,
          variant: 'primary'
        });
        this.getTrashedObjects();
      });
    },
    deleteObject(object) {
      this.objectToDelete = Object.assign({}, object);
      this.$bvModal.show('bv-modal-trash-delete-object');
    }
  },
  mounted() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
      return;
    }

    if(this.section != 'monitors') {
      this.$store.dispatch(GLOBAL_CHANGE_SECTION, 'monitors');
      this.getMonitorsData();
    }

    this.type = this.$route.params.type;
    this.tagId = this.$route.params.tagId;

    this.generateTagsNames();
    this.getTrashedObjects(); 
  }
}
</script>

<style lang="scss">
.trash {

  &__item-date {
    white-space: nowrap;
  }
}
</style>